<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
            <!-- //文本搜索内容 -->
            <div class="fun-panel fun-search-form-wrapper">
                <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="入库单编号">
                                <a-input v-model="queryParams.rkdbh" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="单据状态">
                                <FGDictSelectCN dictNo="XZJ200104" v-model="queryParams.djzt" placeholder="" mode="multiple" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="专家姓名">
                                <a-input v-model="queryParams.xm" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="专家身份证号">
                                <a-input v-model="queryParams.sfzh" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <span class="fun-search-form-buttons" :style="{ float: 'right', overflow: 'hidden' }">
                                <a-button type="primary" @click="loadData" style="margin-right: 8px">查询</a-button>
                                <a-button @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-anchor>
        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <vxe-toolbar
                    size="mini"
                    custom
                    :refresh="{
                        query: () => {
                            this.loadData();
                        }
                    }"
                >
                    <template v-slot:buttons>
                        <a-button type="primary" icon="plus" @click="insert">新增</a-button>
                        <a-button v-show="editShow" type="primary" style="margin-left: 10px" @click="batchSubmit()">提交</a-button>
                        <a-button-group class="btnGroupCls">
                            <a-button :type="selDJZT === 0 ? btnPrimary : btnDefault" @click="handleSelDjztChange(0)">
                                全部
                            </a-button>
                            <a-button :type="selDJZT === 1 ? btnPrimary : btnDefault" @click="handleSelDjztChange(1)">
                                待提交
                            </a-button>
                            <a-button :type="selDJZT === 2 ? btnPrimary : btnDefault" @click="handleSelDjztChange(2)">
                                已提交
                            </a-button>
                        </a-button-group>
                    </template>
                </vxe-toolbar>

                <vxe-table
                    ref="table"
                    size="mini"
                    resizable
                    row-id="id"
                    auto-resize
                    align="left"
                    :max-height="$FG_util.getTableHeightDirect(2)"
                    show-overflow="tooltip"
                    header-align="center"
                    :data="tableData"
                    highlight-hover-row
                    highlight-current-row
                    :checkbox-config="{ trigger: 'row' }"
                    :sort-config="{
                        trigger: 'cell',
                        defaultSort: { field: sort.field, order: sort.order },
                        remote: true,
                        orders: ['asc', 'desc']
                    }"
                    @sort-change="handleSortChange"
                    @cell-dblclick="doubleClick"
                >
                    <vxe-table-column width="50" type="checkbox" align="center"> </vxe-table-column>
                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                    <vxe-table-column field="djzt" title="单据状态" width="80" align="center"></vxe-table-column>
                    <vxe-table-column field="rkdbh" title="入库单编号" width="120" align="center" sortable></vxe-table-column>
                    <vxe-table-column field="gzdw" title="工作单位" min-width="130"></vxe-table-column>
                    <vxe-table-column field="xm" title="姓名" width="100" align="center" sortable></vxe-table-column>
                    <vxe-table-column field="xb" title="性别" width="80" align="center"></vxe-table-column>
                    <vxe-table-column field="sfzh" title="身份证号" width="150" align="center" sortable></vxe-table-column>
                    <vxe-table-column field="lrbmmc" title="录入部门" width="100" align="center"> </vxe-table-column>
                    <vxe-table-column field="lrrxm" title="录入人" width="120" align="center"> </vxe-table-column>
                    <vxe-table-column field="lrrq" title="录入时间" align="center" width="100" sortable>
                        <template v-slot="{ row }">
                            <span> {{ $FG_util.formatDateAllowNull(row.lrrq, "YYYY-MM-DD") }} </span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column title="操作" align="center" width="160">
                        <template v-slot="scope">
                            <span class="btn_edit" v-if="scope.row.djzt === '制定' || scope.row.djzt === '撤销'" @click="remove(scope.row)">删除</span>
                            <span class="btn_edit" v-if="scope.row.djzt === '制定' || scope.row.djzt === '撤销'" @click="edit(scope.row)">编辑</span>
                            <span class="btn_edit" @click="view(scope.row)">查看</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "ZjxxrkBrowse",
    components: {},
    data() {
        return {
            tableData: [], //表格数据
            queryParams: { funid: "ZJ2001" },
            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 20,
                total: 0
            },
            // 排序
            sort: {
                field: "rkdbh",
                order: "desc"
            },
            tableDataLoading: false,
            btnPrimary: "primary",
            btnDefault: "default",
            selDJZT: 1,
            isShow: false
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        editShow() {
            if (this.selDJZT === 1) {
                return true;
            } else {
                return false;
            }
        }
    },
    activated() {
        this.loadData(this.editDataId);
    },
    methods: {
        //双击事件
        doubleClick({ row }) {
            if (this.getState(row.djzt) === 2) {
                this.view(row);
            } else {
                this.edit(row);
            }
        },
        getState(state) {
            if (state === "制定" || state === "撤销" || state === "否决") {
                return 1;
            } else {
                return 2;
            }
        },
        //选择不同状态
        handleSelDjztChange(djzt) {
            this.selDJZT = djzt;
            this.loadData();
        },
        //点击页码
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //点击表头排序
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        //查询列表数据
        loadData(id) {
            this.queryParams.selType = this.selDJZT;
            // 如果没有指定选中记录则选中刷新前选中的记录
            if (!id) {
                let row = this.$refs.table.getCurrentRecord();
                if (row) {
                    id = row.id;
                }
            }
            this.tableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zjxx/xzjrkgl/list",
                    {
                        funid: "XZJ2001",
                        defaulttablename: "XZJ_ZJRKB",
                        pageNo: this.pageinfo.pageNo,
                        pageSize: this.pageinfo.pageSize,
                        queryParams: this.queryParams,
                        sort: this.sort
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        this.tableData = data.data;
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.pageinfo.pageNo = data.pageinfo.pagenum;
                        this.pageinfo.total = data.pageinfo.maxrow;
                    } else {
                        // 数据加载失败清空表格
                        this.tableData = [];
                    }
                })
                .then(() => {
                    this.$nextTick(() => {
                        let row = null;
                        // 获取之前选择的记录
                        if (id) {
                            row = this.$refs.table.getRowById(id);
                        }
                        // 如果之前没有选择记录且表格不为空则选择第一条记录
                        if (!row && this.tableData.length > 0) {
                            row = this.$refs.table.getRowById(this.tableData[0].id);
                        }
                        if (row) {
                            // 设置当前记录
                            this.$refs.table.setCurrentRow(row);
                        } else {
                            // 清空当前行
                            this.$refs.table.clearCurrentRow();
                        }
                    });
                });
        },
        //重置文本内容
        reset() {
            this.queryParams = {};
        },
        // 新增
        insert() {
            this.tableDataLoading = true;
            this.$FG_http
                .post("./api/main/zjxx/xzjrkgl/validateBeforeInsert", {
                    dwid: this.getUserInfo.companyInfo.id,
                    dwlb: this.getUserInfo.companyInfo.dwlb
                })
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        // 没有校验问题，设置编辑记录id为 null，并显示编辑界面
                        this.editDataId = null;
                        this.editIsVisible = true;
                    } else {
                        // 校验失败，显示错误信息
                    }
                })
                .finally(() => {
                    this.tableDataLoading = false;
                });
        },
        // 编辑
        edit(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            // 显示编辑界面
            this.editIsVisible = true;
            this.formIsVisible = false;
        },
        // 查看
        view(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            // 显示编辑界面
            this.editIsVisible = false;
            this.formIsVisible = true;
        },
        //删除
        remove(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    this.tableDataLoading = true;
                    this.$FG_http
                        .post("./api/main/zjxx/xzjrkgl/delete", {
                            id: row.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                this.loadData(row.id);
                            }
                        });
                }
            });
        },
        batchSubmit() {
            let selectRecords = this.$refs.table.getCheckboxRecords();
            // 保存操作
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.tableDataLoading = true;
                    this.$FG_http
                        .post("./api/main/zjxx/xzjrkgl/batchSubmit", {
                            updateData: selectRecords.map((item) => {
                                return item.id;
                            })
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            this.loadData();
                        });
                }
            });
        }
    }
};
</script>
